import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  static targets = ['top']

  connect() {
    on('scroll', this.scrolled)
    on('resize', this.resized)
    this.prevPageYOffset = window.scrollY
  }

  disconnect() {
    off('scroll', this.scrolled)
    off('resize', this.resized)
  }

  get topHeight() {
    return this.topTarget.getBoundingClientRect().height
  }

  scrolled = () => {
    if (!this.isMobile) {
      this.showTop()
      return
    }

    const pageYOffset = window.scrollY
    if (this.prevPageYOffset > pageYOffset) {
      this.showTop()
    }
    else if (this.prevPageYOffset < pageYOffset) {
      this.showTop(false)
    }
    this.prevPageYOffset = pageYOffset
  }

  resized = () => {
    if (!this.isMobile) {
      this.showTop()
    }
  }

  showTop = (show = true) => {
    this.topTarget.style.top = show ? '0' : `-${this.topHeight}px`
  }

  get isMobile() {
    return window.matchMedia('(max-width: 768px)').matches
  }
}
